/***************************************************************************
 * This file registers the category for all blocks
 * It must match the name found in blocks.json
 * To edit the name that appears in the UI, edit BOTH block.json of each
 * block and deohs_gutenberg_blocks.guttenberg.yml
 ***************************************************************************/

import { registerBlockType } from '@wordpress/blocks';
import { select, dispatch } from '@wordpress/data';

// Define the custom category
const category = {
    slug: 'deohs-gutenberg-blocks',
    title: 'UW DEOHS BLOCKS'
};

// Register the custom category if it doesn't exist. Credit to CE Gutenberg block for this snippet.
const currentCategories = select('core/blocks').getCategories().filter(item => item.slug !== category.slug);
dispatch('core/blocks').setCategories([category, ...currentCategories]);

// Import each block
import DEOHSCardGroup from './deohs-card-group';
import DEOHSGridCardProfile from './deohs-grid-card-profile-group';

import DEOHSVerticalCard2 from './deohs-card-vertical01';
import DEOHSHorizontalCard from './deohs-card-horizontal';
import DEOHSCardNoImage from './deohs-card-no-image';
import DEOHSSquareCard from './deohs-card-square';
import DEOHSProfileCard from './deohs-profile-card';

import DEOHSFastFacts from './deohs-fast-facts';
import DEOHSButton from './deohs-button';
import DEOHSFullWidthContainer from './deohs-full-width-container';
import DEOHSCallOutBox from './deohs-callout-box';
import DEOHSPullQuote from './deohs-pull-quote';
import DEOHSImageBackedCard from './deohs-image-backed-card';
import DEOHSAccordion from './deohs-accordion-container';
import DEOHSAccordionItem from './deohs-accordion-container/deohs-accordion-item';

// Utility function to register blocks
function registerBlock(block) {
    if (!select('core/blocks').getBlockType(block.name)) {
        registerBlockType(block.name, block);
    }
}



// This determines the order in which blocks appear in side panel

registerBlock(DEOHSCardGroup);
registerBlock(DEOHSGridCardProfile);

registerBlock(DEOHSFastFacts);
registerBlock(DEOHSButton);

registerBlock(DEOHSFullWidthContainer);
registerBlock(DEOHSCallOutBox);
registerBlock(DEOHSPullQuote);
registerBlock(DEOHSAccordion);
registerBlock(DEOHSAccordionItem);

registerBlock(DEOHSProfileCard);
registerBlock(DEOHSVerticalCard2);
registerBlock(DEOHSHorizontalCard);
registerBlock(DEOHSCardNoImage);
registerBlock(DEOHSSquareCard);
registerBlock(DEOHSImageBackedCard);
